import { render, staticRenderFns } from "./measure-skeleton.vue?vue&type=template&id=41c5faee&"
import script from "./measure-skeleton.vue?vue&type=script&lang=js&"
export * from "./measure-skeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports